module.exports = __webpack_public_path__ + "img/gxjs.6d1db8c7.png";